import { createSelector } from '@reduxjs/toolkit';

import featureApi from '@/slices/features/feature.api';
import type { Feature } from '@/slices/features/feature.types';
import type { RootState } from '@/store';

const EMPTY_FEATURES: Feature[] = [];

const selectEnabledFeatures = (state: RootState): Feature[] =>
  featureApi.endpoints.getEnabledFeatures.select()(state).data ??
  EMPTY_FEATURES;

const selectFeatureName = (_state: RootState, featureName: string): string =>
  featureName;

export const isFeatureEnabled = createSelector(
  [selectEnabledFeatures, selectFeatureName],
  (enabledFeatures, featureName): boolean =>
    enabledFeatures.some((feature) => feature.name === featureName),
);
